module.exports = __webpack_public_path__ + "static/media/icon-12.80101371.png";